// components/ExportOrdersForm.jsx
import React, { useState } from "react";
import { Box, TextField, MenuItem } from "@material-ui/core";
import Button from "components/CustomButtons/Button.js";
import { BASE_URL_API } from "services/Http";
import ManagerDashboardService from "services/ManagerDashboardService";
import useDealersSwr from "hooks/useDealersSwr"; // ✅ nuevo import

/**
 * Form to handle the generation and download of the orders report.
 *
 * @param {Object} props
 * @param {Function} props.closeDialog - Function to close the modal
 */
export default function ExportOrdersForm({ closeDialog }) {
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [dealerId, setDealerId] = useState("");
    const [loading, setLoading] = useState(false);

    const { dealers, isLoading: loadingDealers } = useDealersSwr("", 1, 1000);

    const handleExport = async () => {
        try {
            setLoading(true);
            const response = await ManagerDashboardService.exportOrdersReport({
                startDate,
                endDate,
                dealerId,
            });

            if (response?.filePath) {
                const excelFilePath = response.filePath;
                if (excelFilePath.startsWith("http")) {
                    window.location.href = excelFilePath;
                } else {
                    const baseDownloadUrl = BASE_URL_API.replace("/api", "");
                    window.location.href = `${baseDownloadUrl}${excelFilePath}`;
                }
            }
        } catch (error) {
            console.error("Error exporting report:", error);
            alert("There was a problem generating the report.");
        } finally {
            setLoading(false);
            closeDialog();
        }
    };

    return (
        <Box display="flex" flexDirection="column">
            <TextField
                label="Start Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                fullWidth
                style={{ marginBottom: 12 }}
            />
            <TextField
                label="End Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                fullWidth
                style={{ marginBottom: 12 }}
            />
            <TextField
                label="Dealer (optional)"
                select
                fullWidth
                value={dealerId}
                onChange={(e) => setDealerId(e.target.value)}
                disabled={loadingDealers}
                style={{ marginBottom: 16 }}
            >
                <MenuItem value="">All Dealers</MenuItem>
                {dealers?.data?.map((dealer) => (
                    <MenuItem key={dealer.id} value={dealer.id}>
                        {dealer.company}
                    </MenuItem>
                ))}
            </TextField>
            <Box mt={2} textAlign="center">
                <Button type="button" color="rose" onClick={handleExport} disabled={loading}>
                    {loading ? "Exporting..." : "Export CSV"}
                </Button>
            </Box>
        </Box>
    );
}
